import { Component, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { NestedGroupQuestionV3 } from '../../../classes/question-nestedGroup';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-field-nested-group-v3',
  templateUrl: './field-nested-group.component.html',
  styleUrls: ['./field-nested-group.component.scss'],
  standalone: false
})
export class FieldNestedGroupComponentV3 extends QuestionBaseV3ComponentDirective {
  @Input() question: NestedGroupQuestionV3;
  @Input() color: string;

  get keys(): UntypedFormArray {
    return this.formGroup.get(this.question.key) as UntypedFormArray;
  }
}
